import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

const styles = makeStyles(theme => ({
  button: {
    padding: '1.25rem 0 0.5rem 0',
    marginLeft: '1rem',
    marginRight: '1rem',
    fontSize: '1.2rem',
    fontWeight: 500,
    boxShadow: 'none',
    border: 'none',
    borderBottom: `3px solid ${theme.palette.common.white}`,
    borderRadius: 0,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
      border: 'none',
      borderBottom: `3px solid ${theme.palette.primary.main}`,
    }
  },
  fullButton: {
    minWidth: '6rem',
    marginLeft: '1rem',
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: '1.1rem',
    '&:focus': {
      outline: '-webkit-focus-ring-color auto 1px',
    },
  },
}));

const NavButton = ({children, variant, to, ...props}) => {
  const classes = styles();
  const defaults = {
    to,
    variant: variant || 'text',
    color: 'primary',
    className: classes.button,
  };

  // for contained and outlined use alternative css
  if (['contained', 'outlined'].includes(variant)) {
    defaults.className = classes.fullButton;
  }

  // if to prop is defined, component need to be set to Link
  if (to !== undefined) {
    defaults.component = Link;
  }

  return (
    <Button disableRipple disableFocusRipple {...defaults} {...props}>
      {children}
    </Button>
  );
};

NavButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  to: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
};

export default NavButton;
